import React from 'react';
import { Clock } from 'lucide-react';
import { Select, SelectOption } from './Select';
import { LABEL_TEXT } from './tokens';

interface TimeRangeSelectorProps {
  readonly value: string;
  readonly onChange: (value: string) => void;
  readonly label?: string;
  readonly required?: boolean;
  readonly disabled?: boolean;
  readonly error?: string;
  readonly startHour?: number;
  readonly endHour?: number;
  readonly intervalMinutes?: number;
  readonly className?: string;
}

export const TimeRangeSelector: React.FC<TimeRangeSelectorProps> = ({
  value,
  onChange,
  label,
  required = false,
  disabled = false,
  error,
  startHour = 6,
  endHour = 22,
  intervalMinutes = 30,
  className = '',
}) => {
  const generateTimeOptions = (): SelectOption[] => {
    const options: SelectOption[] = [];

    for (let hour = startHour; hour <= endHour; hour++) {
      for (let minute = 0; minute < 60; minute += intervalMinutes) {
        if (hour === endHour && minute > 0) break;

        const hourStr = hour.toString().padStart(2, '0');
        const minuteStr = minute.toString().padStart(2, '0');

        let endHourNum = hour;
        let endMinuteNum = minute + intervalMinutes;

        if (endMinuteNum >= 60) {
          endHourNum++;
          endMinuteNum = endMinuteNum - 60;
        }

        const endHourStr = endHourNum.toString().padStart(2, '0');
        const endMinuteStr = endMinuteNum.toString().padStart(2, '0');

        const timeValue = `${hourStr}:${minuteStr}-${endHourStr}:${endMinuteStr}`;
        const timeLabel = `${hourStr}:${minuteStr} - ${endHourStr}:${endMinuteStr}`;

        options.push({ value: timeValue, label: timeLabel });
      }
    }

    return options;
  };

  const timeOptions = generateTimeOptions();

  return (
    <div className={className}>
      {label && (
        <label className={`flex items-center gap-1.5 ${LABEL_TEXT} mb-1.5`}>
          <Clock className="w-4 h-4 text-slate-400 shrink-0" />
          {label}
          {required && <span className="text-red-500">*</span>}
        </label>
      )}

      <Select
        options={timeOptions}
        value={value}
        onChange={onChange}
        placeholder="Seleccionar..."
        disabled={disabled}
        error={error}
        required={required}
      />
    </div>
  );
};
